'use client';

import { useState, createContext } from 'react';
import type { TemplateSignUpInProviderProps } from './TemplateSignUpInProvider.types';
import { Firm } from '@/_types/models/firm';

const TemplateSignUpInContext = createContext<TemplateSignUpInProviderProps>({
  firm: undefined,
  firmGroupId: undefined,
  isLoadingTemplateInfo: false,
  setFirm: () => {},
  setFirmGroupId: () => {},
  setIsLoadingTemplateInfo: () => {},
  setTaxYear: () => {},
  setTemplate: () => {},
  setTemplateHashId: () => {},
  setTemplateRedirect: () => {},
  taxYear: undefined,
  template: null,
  templateHashId: undefined,
  templateRedirect: undefined,
});

const TemplateSignUpInProvider = (props: any) => {
  const [templateRedirect, setTemplateRedirect] = useState<string | undefined>(
    undefined,
  );
  const [firm, setFirm] = useState<Firm | undefined>(undefined);
  const [firmGroupId, setFirmGroupId] = useState<string | undefined>(undefined);
  const [taxYear, setTaxYear] = useState<string | undefined>(undefined);
  const [template, setTemplate] = useState(undefined);
  const [templateHashId, setTemplateHashId] = useState<string | undefined>(
    undefined,
  );
  const [isLoadingTemplateInfo, setIsLoadingTemplateInfo] = useState(false);

  return (
    <TemplateSignUpInContext
      value={{
        firm,
        firmGroupId,
        isLoadingTemplateInfo,
        setFirm,
        setFirmGroupId,
        setIsLoadingTemplateInfo,
        setTaxYear,
        setTemplate,
        setTemplateHashId,
        setTemplateRedirect,
        taxYear,
        template,
        templateHashId,
        templateRedirect,
      }}
    >
      {props.children}
    </TemplateSignUpInContext>
  );
};

export { TemplateSignUpInContext, TemplateSignUpInProvider };
